import { MainContentLayout } from 'shared/ui/layout';

import { AddBonusProgram } from 'features/bonus/add-bonus-program';

export function AddBonusProgramPage() {
  return <MainContentLayout element={<AddBonusProgram />} />;
}
